import React from "react";
import "./Healthcare.css";
import Navbar from "../components/Navbar";

const HeavyIndustries = () => {
  return (
    <>
      <Navbar />
      <div className="industry1-container">
        <div className="industry1-content">
          <p className="para">Industries / Manufacturing & Heavy Industries</p>
          <h2>Manufacturing & Heavy Industries</h2>
          <p className="subtitle1">
            Transforming Industrial Operations Through Spatial Intelligence and XR Innovation
          </p>
          <p>
            At Spatial Computing Technologies (SpatialCT), we empower manufacturing and heavy industries with XR (VR/AR/MR), AI, and Spatial Computing to enhance operational efficiency, worker safety, training effectiveness, and digital transformation. Our solutions are designed to solve high-stakes problems across production, assembly, inspection, and maintenance workflows.
          </p>

          <div className="industry1-grid">
            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Immersive Operator Training & Skill Development</h4>
                <p>Simulate real factory floors, machines, and high-risk environments in VR to train operators and technicians safely and efficiently.</p>
                <ul>
                  <li>Machine operation walkthroughs with virtual controls</li>
                  <li>Scenario-based error handling and emergency drills</li>
                  <li>Real-time tracking and analytics on user performance</li>
                </ul>
                <p><strong>Ideal for:</strong> Foundries, fabrication units, OEMs</p>
              </div>

              <div className="industry1-box">
                <h4>Process Simulation & Optimization</h4>
                <p>Digitally replicate end-to-end processes — from raw material input to final product delivery — and optimize workflows using spatial analytics.</p>
                <ul>
                  <li>Visualize time, motion, and process flows in VR</li>
                  <li>Conduct "what-if" testing without halting real production</li>
                  <li>Integrate with ERP/MES systems for real-time validation</li>
                </ul>
                <p><strong>Ideal for:</strong> Manufacturing engineers, operations planners</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>XR-Based Predictive Maintenance & Troubleshooting</h4>
                <p>Use AR headsets or mobile XR apps to visualize component wear, get step-by-step maintenance guidance, and avoid costly breakdowns.</p>
                <ul>
                  <li>Overlay maintenance instructions on physical machines</li>
                  <li>Detect early anomalies with sensor data integration</li>
                  <li>Reduce mean time to repair (MTTR)</li>
                </ul>
                <p><strong>Ideal for:</strong> Equipment-heavy industries, plant maintenance teams</p>
              </div>

              <div className="industry1-box">
                <h4>Safety Protocol Training & Compliance</h4>
                <p>Immerse workers in hazardous situations virtually — electrical faults, gas leaks, fire outbreaks — to practice safety protocols and emergency response.</p>
                <ul>
                  <li>Multi-language VR safety modules</li>
                  <li>Simulated panic environments to study decision-making</li>
                  <li>Performance reports for audits and certification</li>
                </ul>
                <p><strong>Ideal for:</strong> Steel plants, chemical factories, heavy machinery operators</p>
              </div>
            </div>

            <div className="industry1-row">
              <div className="industry1-box">
                <h4>Remote Inspection & Expert Guidance</h4>
                <p>Enable real-time remote support using smart glasses and AR overlays where experts can annotate live feeds and guide on-ground teams.</p>
                <ul>
                  <li>Live collaboration from global HQs</li>
                  <li>Reduce travel and expert availability bottlenecks</li>
                  <li>Speed up maintenance, inspection, and approvals</li>
                </ul>
                <p><strong>Ideal for:</strong> OEMs, large plant facilities, MRO service providers</p>
              </div>
            </div>
          </div>


          {/* Use Cases Table */}
          <div className="usecases-section">
            <h3>Use Cases At a Glance</h3>
            <div className="table-wrapper">
              <div className="usecases-table">
                <div className="usecases-row usecases-header">
                  <div>Use Case</div>
                  <div>Industry</div>
                  <div>Solution Type</div>
                  <div>Benefits</div>
                </div>
                <div className="usecases-row">
                  <div>VR Safety Training</div>
                  <div>Steel, Mining</div>
                  <div>Workforce Safety</div>
                  <div>Fewer incidents, regulatory compliance</div>
                </div>
                <div className="usecases-row">
                  <div>Process Flow Simulation</div>
                  <div>Manufacturing</div>
                  <div>Process Optimization</div>
                  <div>Reduced bottlenecks, lean execution</div>
                </div>
                <div className="usecases-row">
                  <div>AR Maintenance</div>
                  <div>Heavy Equipment</div>
                  <div>Service & Repair</div>
                  <div>Faster fixes, reduced downtime</div>
                </div>
                <div className="usecases-row">
                  <div>XR Onboarding</div>
                  <div>Factories</div>
                  <div>Training</div>
                  <div>Skilled workforce, Lower attrition</div>
                </div>
                <div className="usecases-row">
                  <div>Remote Inspection</div>
                  <div>Multi-plant Enterprises</div>
                  <div>Quality & Compliance</div>
                  <div>Real-time support, cost savings</div>
                </div>
              </div>
            </div>

            <div className="usecases-cta">
              <h4>Let’s Modernize Your Industrial Ecosystem </h4>
              <p>
                    We help industries evolve from conventional practices to immersive, data-driven, and safer 
operations through tailored XR and spatial computing solutions. Whether it's operator training, 
machine maintenance, or optimizing your production pipeline, SpatialCT delivers measurable 
impact. 
              </p>
              <p><strong>Book a demo</strong> or schedule a discovery call today to co-create your smart manufacturing future.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeavyIndustries;
